import { all_routes } from "../../../feature-module/router/all_routes";
const route = all_routes;

export const SidebarData = [
  {
    label: "MAIN DASHBOARD",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Dashboard",
        icon: "ti ti-layout-2",
        showSubRoute: false,
        link: route.Dashboard,
        permission: "ROLE_VIEW_ALL_BOOKINGS", // Accessible to all authenticated users
      },
    ],
  },
  {
    label: "MAIN MENU",
    submenu: true,
    showSubRoute: false,
    submenuHdr: "Main Menu",
    submenuItems: [
      {
        label: "Administration",
        submenu: true,
        showSubRoute: false,
        icon: "ti ti-settings-cog",
        permission: "ADMINISTRATION_ACCESS", // Requires exact match in roles
        submenuItems: [
          { label: "Locations", link: route.viewrooms, permission: "ROLE_GET_LOCATIONS" },
          { label: "Users", link: route.ViewUsers, permission: "ROLE_GET_USERS" },
          // { label: "Rooms", link: route.notification, permission: "ROLE_GET_ROOMS" },
          { label: "Department", link: route.Department, permission: "ROLE_GET_DEPARTMENT" },
          { label: "Gate Management", link: route.RelayDevices, permission: "ROLE_VIEW_GATE" },
        ],
      },
      {
        label: "Gate Controller",
        icon: "ti ti-door",
        link: route.GateController,
        permission: "ROLE_VIEW_GATE",
      },
      {
        label: "Vehicle Management",
        submenu: true,
        showSubRoute: false,
        icon: "ti ti-car",
        permission: "VEHICLE_MANAGER_ACCESS", // Requires exact match in roles
        submenuItems: [
          // { 
          //   label: "Dashboard", 
          //   link: route.companySettings, 
          //   permission: "SERVICE_MANAGER" 
          // },
          {
            label: "Vehicles",
            link: route.VehicleDashboard,
            permission: "SERVICE_MANAGER"
          },

          {
            label: "Booking",
            link: route.booking,
            permission: "ROLE_ADD_VEHICLE_BOOKING" // Only grants booking access; does NOT imply ROLE_ADD_VEHICLE
          },
          {
            label: "New Booking",
            link: route.newBooking,
            permission: "ROLE_ADD_VEHICLE_BOOKING" // Only grants booking access; does NOT imply ROLE_ADD_VEHICLE
          },
          {
            label: "Service",
            link: route.service,
            permission: "ROLE_ADD_USERS" // Requires exact match; NOT granted by ROLE_ADD_VEHICLE_BOOKING
          },
          {
            label: "Employee Vehicle",
            link: route.addEmployeeVehicle,
            permission: "ROLE_MANAGE_EMPLOYEE_VEHICLE" // Requires exact match; NOT granted by ROLE_ADD_VEHICLE_BOOKING
          },
        ],
      },
      {
        label: "Key Management",
        submenu: true,
        showSubRoute: false,
        icon: "ti ti-key",
        permission: "VEHICLE_MANAGER_ACCESS", // Requires exact match in roles
        submenuItems: [
          { label: "Key Dashboard", link: route.keydashboard, permission: "ROLE_REQUEST_KEY" },
          { label: "Key Allocations", link: route.keyAllocations, permission: "ROLE_VIEW_ALL_BOOKINGS" },
          { label: "Key Request", link: route.keyrequest, permission: "ROLE_REQUEST_KEY" },

        ],
      },
      {
        label: "Visitor Management",
        submenu: true,
        showSubRoute: false,
        icon: "ti ti-user",
        permission: "ROLE_ADD_VISITOR_REQUEST", // Requires exact match in roles
        submenuItems: [
          { label: "Visitor Dashboard", link: route.Visitor, permission: "ROLE_ADD_VISITOR_REQUEST" },
          { label: "Visitor Request", link: route.visitorRequest, permission: "ROLE_ADD_VISITOR_REQUEST" },

        ],
      },
      {
        label: "Facility Maintenance",
        submenu: true,
        showSubRoute: false,
        icon: "ti ti-archive",
        permission: "FACULTY_MAINTENANCE_ACCESS",
        submenuItems: [
          {
            label: "Job Card Dashboard",
            link: route.maintenanceTasksDashboard,
            permission: "ROLE_GET_FACULTY_MANAGEMENT_DASHBOARD_SUMMARY"
          },
          { label: "Job Card", link: route.jobCards, permission: "ROLE_ADD_TASK" },
          { label: "Items Serivce", link: route.itemServiceCards, permission: "ROLE_ADD_ITEM" },
        ],
      },
      {
        label: "Letter Management",
        submenu: true,
        showSubRoute: false,
        icon: "ti ti-receipt",
        permission: "LETTER_REGISTRATION_ACCESS", // Requires exact match in roles
        submenuItems: [
          { label: "Letters", link: route.letter, permission: "ROLE_GET_VEHICLE_SERVICE_DATA" },
          { label: "Department Letters", link: route.departmentLetters, permission: "ROLE_PENDING_VEHICLE_BOOKING" },
        ],
      },
    ],
  },
];